var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"overlayer"},[_c('b-spinner',{staticClass:"centerer",attrs:{"type":"grow","variant":"success"}})],1):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }